import React, {useCallback, useEffect} from "react";
import {
    selectTokens,
    setApplicationVersion,
    setEmailAddress,
    setLoginState,
    setTokens,
    setUnity
} from "../../features/states/slices";
import {useDispatch, useSelector} from "react-redux";
import {getNewTokenValueFromAWS, getTokenValueFromAWS, SignOutOfClient} from "../../functions/AmplifyFunctions";
import {useNavigate} from "react-router-dom";

export function SendNullToken() {
    if (window.vuplex) {
        const token = {
            type: 'accessToken',
            value: ""
        }
        window.vuplex.postMessage(token)

        const project = {
            type: 'projectInfo',
            value: ""
        }
        window.vuplex.postMessage(project)
    }
}

export function SendMessageToUnity(type, value) {
    if (window.vuplex) {
        const params = {
            type: type,
            value: value
        }
        window.vuplex.postMessage(params)
    }
}

export function UnityLink(URL) {
    if (window.vuplex) {
        const params = {
            type: 'webLink',
            value: URL
        }
        window.vuplex.postMessage(params)
    } else {
        window.open(URL, "_blank", 'noreferrer')
    }
}

export async function OpenAssetConfig(){
    await getNewTokenValueFromAWS()
    const params = {
        type: 'openCommands',
        value: 'AssetConfig'
    }
    window.vuplex.postMessage(params)
}

function normalizeUnityEmailAddress(value) {
    if (typeof value !== "string") {
        return null;
    }

    const trimmedValue = value.trim().toLowerCase();
    if (!trimmedValue.includes("@")) {
        return null;
    }

    return trimmedValue;
}

export default function UnityCommandsContext(props) {

    const dispatch = useDispatch()
    const tokens = useSelector(selectTokens);
    const navigate = useNavigate();

    window.GetRefreshToken = () => {
        return tokens.refreshToken;
    }

    window.GetAccessToken = () => {
        return tokens.accessToken;
    }

    window.GetNewAccessToken = () => {
        if(window.vuplex){
            getNewTokenValueFromAWS()
        }
    }

    useEffect(() => {
        if (!props.userloggedIn) {
            return;
        }
        getTokenValue();
    }, [props.userloggedIn])

    window.GetTokenValues = () => {
        getTokenValue();
    }

    async function getTokenValue() {
        await getTokenValueFromAWS()
    }

    const handleUnityLoginToken = useCallback((payload) => {
        const accessToken = typeof payload?.token === "string" && payload.token.trim().length
            ? payload.token.trim()
            : typeof payload?.accessToken === "string" && payload.accessToken.trim().length
                ? payload.accessToken.trim()
                : null;

        if (!accessToken) {
            return;
        }

        const idToken = typeof payload?.idToken === "string" && payload.idToken.trim().length
            ? payload.idToken.trim()
            : null;
        const refreshToken = typeof payload?.refreshToken === "string" && payload.refreshToken.trim().length
            ? payload.refreshToken.trim()
            : null;

        dispatch(setTokens({
            accessToken,
            idToken,
            refreshToken,
        }));
        dispatch(setLoginState(true));

        const normalizedEmailAddress = normalizeUnityEmailAddress(payload?.userEmail);
        if (normalizedEmailAddress) {
            dispatch(setEmailAddress(normalizedEmailAddress));
        }
    }, [dispatch]);

    useEffect(() => {
        if (tokens.idToken !== null) {
            /* SendJWTToken(); */
        }
    }, [tokens.idToken])

    const sendRefreshToken = useCallback(() => {
        if (window.vuplex && tokens.refreshToken !== null) {
            const params = {
                type: 'refreshToken',
                value: tokens.refreshToken
            }
            window.vuplex.postMessage(params)
        }
    }, [tokens.refreshToken]);

    const sendAccessToken = useCallback(() => {
        if (window.vuplex && tokens !== null && tokens.accessToken !== undefined) {
            const params = {
                type: 'accessToken',
                value: tokens.accessToken
            }
            window.vuplex.postMessage(params)
        }
    }, [tokens]);

    useEffect(() => {
         if (tokens.accessToken !== null) {
            sendAccessToken();
        }
    }, [sendAccessToken, tokens.accessToken])

    useEffect(() => {
        if (tokens.refreshToken !== null) {
            sendRefreshToken();
        }
    }, [sendRefreshToken, tokens.refreshToken])


    const setUpStartup = useCallback(() => {
        if (!window.vuplex) {
            return undefined;
        }

        dispatch(setUnity(true))
        const params = {
            type: 'webLoad',
            value: "Hello World"
        }
        window.vuplex.postMessage(params)

        const handleVuplexMessage = (event) => {
            let obj = null;
            try {
                obj = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
            } catch (error) {
                return;
            }

            if (!obj || typeof obj !== "object") {
                return;
            }

            if (obj.type === 'loginToken') {
                handleUnityLoginToken(obj);
            }

            if(obj.type === 'applicationVersion'){
                dispatch(setApplicationVersion(obj.value))
            }

            if(obj.type === 'logoutUser'){
                SignOutOfClient()
                navigate("/")
            }
        };

        window.vuplex.addEventListener('message', handleVuplexMessage);

        return () => {
            if (window.vuplex?.removeEventListener) {
                window.vuplex.removeEventListener('message', handleVuplexMessage);
            }
        };
    }, [dispatch, handleUnityLoginToken, navigate]);

    useEffect(() => {
        if (window.vuplex) {
            return setUpStartup();
        }

        window.addEventListener('vuplexready', setUpStartup);
        return () => {
            window.removeEventListener('vuplexready', setUpStartup);
        };
    }, [setUpStartup])

    const {children} = props;

    return <>{children}</>;
};
